import { render } from "./AddDebit.vue?vue&type=template&id=0d52fe25"
import script from "./AddDebit.vue?vue&type=script&lang=js"
export * from "./AddDebit.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__